import React from 'react';
import classNames from 'classnames';
import { Theme } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'services/localization/useTranslation';
interface OwnProps {
	message: string;
	actionHasBeenConfirmed: boolean;
	error?: boolean;
	handleClose: () => void;
}

type Props = OwnProps & WithStyles<typeof styles>;

export const ActionConfirmFeedback = (props: Props) => {
	const { classes, message, actionHasBeenConfirmed, error, handleClose } = props;
	const { t } = useTranslation();

	return (
		<Snackbar
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
			classes={{
				root: classes.snackRoot,
			}}
			open={actionHasBeenConfirmed}
			autoHideDuration={3000}
			onClose={handleClose}
			ContentProps={{
				'aria-describedby': 'message-id',
				classes: {
					root: classNames(classes.contentRoot, error && classes.errorColor),
					message: classes.contentMessage,
					action: classes.contentAction,
				},
			}}
			message={<span>{message}</span>}
			action={[
				<IconButton
					key="close"
					aria-label={t('common:actions.close')}
					color="inherit"
					className={classes.close}
					onClick={handleClose}
					size="large"
				>
					<CloseIcon />
				</IconButton>,
			]}
		/>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		snackRoot: {
			width: `calc(100% - ${theme.spacing(2)})`,
			bottom: 0,
			marginBottom: theme.spacing(1),
		},
		contentRoot: {
			backgroundColor: theme.palette.success.main,
			maxWidth: 'none',
			flexGrow: 1,
			padding: theme.spacing(1),
		},
		errorColor: {
			backgroundColor: theme.palette.error.main,
		},
		contentMessage: {
			margin: '0 auto',
			padding: 0,
		},
		contentAction: {
			margin: 0,
			padding: 0,
		},
		close: {
			padding: theme.spacing(0.5),
		},
	});

export default withStyles(styles)(ActionConfirmFeedback);
